(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["el-inside"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.el-inside__link');
    if (!a) return;
    var t = document.getElementById((a.getAttribute('href') || '').slice(1));
    if (t && t.tagName === 'DETAILS') t.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["el-ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Slow sideways drift for [data-el-ugc] strips. Runs only while the strip is on screen, the tab is visible and the
    // visitor has not asked for reduced motion; pauses on real mouse hover, keyboard focus and for a few seconds after
    // any swipe, wheel or drag, then carries on from wherever the visitor left it. Touch taps must not pause it for
    // good: phones emulate mouseenter on tap and focus a tabindex element on tap, so those two only count with a fine
    // pointer / :focus-visible. The track holds the list three times, so the
    // drift wraps by one set's width without a visible jump.
    function init(root) {
      if (root.dataset.elUgcReady) return;
      root.dataset.elUgcReady = '1';
      var vp = root.querySelector('[data-el-ugc-viewport]');
      if (!vp) return;
      var track = vp.firstElementChild;
      var speed = parseFloat(root.dataset.speed) || 30;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      var pos = 0, last = 0, raf = 0, running = false, onScreen = false, hover = false, focus = false, holdUntil = 0;
      var period = function () { return track.firstElementChild.getBoundingClientRect().width; };
      var hold = function () { holdUntil = performance.now() + 3500; };

      function tick(t) {
        raf = 0;
        if (!running) return;
        var dt = last ? Math.min(t - last, 64) : 16;
        last = t;
        if (t >= holdUntil) {
          pos += (speed * dt) / 1000;
          var h = period();
          if (h > 0 && pos >= h) pos -= h;
          vp.scrollLeft = pos;
        }
        raf = requestAnimationFrame(tick);
      }
      function update() {
        var should = onScreen && !hover && !focus && !reduce.matches && document.visibilityState === 'visible';
        if (should && !running) {
          running = true;
          last = 0;
          pos = vp.scrollLeft;
          raf = requestAnimationFrame(tick);
        } else if (!should && running) {
          running = false;
          if (raf) cancelAnimationFrame(raf);
          raf = 0;
        }
      }

      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { vp.addEventListener(ev, hold, { passive: true }); });
      vp.addEventListener('scroll', function () {
        if (running && performance.now() >= holdUntil) return; // our own drift
        var h = period();
        if (h > 0 && vp.scrollLeft >= h) vp.scrollLeft -= h;
        pos = vp.scrollLeft;
      }, { passive: true });
      vp.addEventListener('mouseenter', function () { if (fineHover.matches) { hover = true; update(); } });
      vp.addEventListener('mouseleave', function () { hover = false; update(); });
      vp.addEventListener('focusin', function () {
        var kb = true;
        try { kb = vp.matches(':focus-visible'); } catch (e) {}
        if (kb) { focus = true; update(); }
      });
      vp.addEventListener('focusout', function () { focus = false; update(); });
      document.addEventListener('visibilitychange', update);
      if (reduce.addEventListener) reduce.addEventListener('change', update);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { onScreen = entries[0].isIntersecting; update(); }, { rootMargin: '100px 0px' }).observe(vp);
      } else {
        onScreen = true;
        update();
      }
    }
    function initAll() { document.querySelectorAll('[data-el-ugc]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
